import React from 'react';
import { Typography, Card, List } from 'antd';
import CodeBlock from './CodeBlock';

const { Title, Text } = Typography;

const ServiceStatus = ({ onCopy }) => {
  const rapidCommands = [
    {
      code: '/etc/rapid/',
      description: 'Rapid Folder Path:',
      subDescription: 'Directory containing configuration files for rapid services.\nUse to locate service-related files.',
    },
    {
      code: 'systemctl status rapid',
      description: 'Service Control Commands:',
      subDescription: 'Displays the current status of the rapid service.\nShows if the service is running or stopped.',
    },
    {
      code: 'systemctl start rapid',
      subDescription: 'Starts the rapid service if it is not running.\nInitiates service operations.',
    },
    {
      code: 'systemctl restart rapid',
      subDescription: 'Restarts the rapid service to apply changes.\nStops and then starts the service.',
    },
    {
      code: 'systemctl restart rapid servicemonitor',
      subDescription: 'Restarts both rapid and servicemonitor services together.\nUseful when both services need to be restarted.',
    },
  ];

  const monitorCommands = [
    {
      code: 'systemctl status servicemonitor',
      description: 'ServiceMonitor Control Commands:',
      subDescription: 'Displays the current status of the servicemonitor service.\nShows if the service is running or stopped.',
    },
    {
      code: 'systemctl start servicemonitor',
      subDescription: 'Starts the servicemonitor service if it is not running.\nInitiates service operations.',
    },
    {
      code: 'systemctl restart servicemonitor',
      subDescription: 'Restarts the servicemonitor service to apply changes.\nStops and then starts the service.',
    },
  ];

  const serviceFiles = [
    {
      code: '/etc/lib/systemd/system/',
      description: 'Service File Location:',
      subDescription: 'Directory for systemd service unit files.\nContains service configuration files.',
    },
  ];

  const fileList = [
    'rapid.service',
    'servicemonitor.service',
    'Executables: mqtt, servicemonitor',
  ];

  return (
    <Card title="Check Rapid Service Status" bordered={false} style={{ backgroundColor: 'var(--card-bg)' }}>
      {rapidCommands.map((command, index) => (
        <CodeBlock
          key={index}
          code={command.code}
          description={command.description}
          subDescription={command.subDescription}
          onCopy={onCopy}
        />
      ))}

      <List
        size="small"
        bordered
        dataSource={fileList}
        renderItem={(item) => <List.Item style={{ color: 'white' }}>{item}</List.Item>}
        style={{ marginBottom: 24 }}
      />

      {monitorCommands.map((command, index) => (
        <CodeBlock
          key={index}
          code={command.code}
          description={command.description}
          subDescription={command.subDescription}
          onCopy={onCopy}
        />
      ))}

      {serviceFiles.map((file, index) => (
        <CodeBlock
          key={index}
          code={file.code}
          description={file.description}
          subDescription={file.subDescription}
          onCopy={onCopy}
        />
      ))}

      <List
        size="small"
        bordered
        dataSource={['rapid.service', 'servicemonitor.service']}
        renderItem={(item) => <List.Item style={{ color: 'white' }}>{item}</List.Item>}
      />
    </Card>
  );
};

export default ServiceStatus; 